<template>
  <div id="wallet_details">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.search_order')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow >
      <template #title>
        <div class="coin-seller_nav">
          <van-tabs v-model="navTab" line-width="15px" @click="navTabBtn" :before-change="beforeTabChange">
            <van-tab title="details" name="details"></van-tab>
            <van-tab title="Cash Out Order" name="Order"></van-tab>
          </van-tabs>
        </div>
      </template>
    </van-nav-bar>
    <!-- 订单状态 -->
    <van-col span="24" class="wallet_details_order_type">
      <van-col span="12" offset="1" v-if="navTab ==='details'">
        <van-cell is-link arrow-direction="down" :title="detailsColumns[details_i].text" @click="detailsShow = true" />
      </van-col>
      <van-col span="12" offset="1" v-else>
        <van-cell is-link arrow-direction="down" :title="OrderColumns[order_i].text" @click="orderShow = true" />
      </van-col>
    </van-col>
    <van-col span="22" offset="1" class="wallet_details_order_list" v-if="navTab ==='details'">
      <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
          @load="onLoad"
      >
        <van-cell v-for="(o,i) in details_list" :key="i" class="wallet_details_order_list_cell">
          <van-col span="16">
            <van-col span="24" class="wallet_details_order_list_cell_left_name"> {{ o.content }}</van-col>
            <van-col span="24" class="wallet_details_order_list_cell_left_correlation_name" v-if="o.correlation_name">
              <img :src="o.correlation_img"/> {{ o.correlation_name }}(ID:{{ o.correlation_uid }})
            </van-col>
            <van-col span="24" class="wallet_details_order_list_cell_left_time"> {{ o.create_time }} </van-col>
          </van-col>
          <van-col span="8" class="wallet_details_order_list_cell_right">
            {{ o.profit > 0 ? '+' + o.profit : o.profit }} <img src="../assets/img/coin9.png"/>
          </van-col>
        </van-cell>
      </van-list>
    </van-col>
    <van-col span="22" offset="1" class="withdraw_payroll_search_order_list" v-else>
      <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
          @load="onLoad"
      >
        <van-cell v-for="(o,i) in list" :key="i" class="wallet_details_order_cell">
          <!-- 订单金额 -->
          <van-col span="22" offset="1" class="wallet_details_order_padding">
            <van-col span="12" class="wallet_details_order_money" @click="detailsOrder(o)">
              <span>{{ o.currency_type_code }} {{ o.cash_amount }} </span>
              {{ $t('column.details') }}
              <van-icon name="arrow" size="14" color="#1A1A1A"/></van-col>
            <van-col span="12" class="wallet_details_order_money_status">
              <van-tag :color="tag_color(o)">
                <van-icon name="checked" v-if="o.result_status === '1'"/>
                <van-icon name="clear" v-else-if="o.result_status === '2'"/>
                <van-icon name="warning" v-else/>  {{ o.result_text }}
              </van-tag>
            </van-col>
            <van-col span="24">
              <van-col span="12" class="wallet_details_order_money_method">{{ $t('column.payment_method') }}</van-col>
              <van-col span="12" class="wallet_details_order_money_method_right">
                <van-col span="24" class="wallet_details_order_money_method_right_name">{{ o.payment_method_name }}</van-col>
                <van-col span="24" class="wallet_details_order_money_method_right_img"><img :src="o.payment_method_img"/> </van-col>
              </van-col>
            </van-col>
            <van-col span="24">
              <van-col span="8" class="wallet_details_order_account">{{ $t('column.account') }}</van-col>
              <van-col span="16" class="wallet_details_order_account_val">{{ o.account_name }}</van-col>
            </van-col>
            <van-col span="16" class="wallet_details_order_time">{{ o.create_time }}</van-col>
          </van-col>

          <!-- 倒计时和操作按钮 -->
          <van-col span="22" offset="1" class="order-actions">
            <van-col span="8" class="countdown-section">
              <van-icon name="clock-o" color="#ff9500" size="16"  v-if="o.countdown_time"/>
              <van-count-down :time="o.countdown_time"  v-if="o.countdown_time"/>
            </van-col>
            <van-col span="16" class="details-btn-section" v-if="o.status === '1' && o.result_status == 0">
              <!--  审核     -->
              <van-button color="#939393" size="small" plain round @click="OrderExceptionButton(o)">{{ $t('column.not_received') }}</van-button>
              <van-button color="#FF61F5" size="small" plain round @click="ConfirmationPaymentButton(o)">{{ $t('column.received') }}</van-button>
            </van-col>
          </van-col>
        </van-cell>
      </van-list>
    </van-col>
    <van-popup v-model="detailsShow" position="bottom" :style="{ height: '40%' }">
      <van-picker
          :title="$t('column.filter')"
          show-toolbar
          :columns="detailsColumns"
          :confirm-button-text="$t('btn.confirm')"
          :cancel-button-text="$t('btn.cancel')"
          @confirm="onConfirm"
          @cancel="detailsShow = false"
      />
    </van-popup>
    <van-popup v-model="orderShow" position="bottom" :style="{ height: '40%' }">
      <van-picker
          :title="$t('column.select_type')"
          show-toolbar
          :columns="OrderColumns"
          :confirm-button-text="$t('btn.confirm')"
          :cancel-button-text="$t('btn.cancel')"
          @confirm="onConfirmOrder"
          @cancel="detailsShow = false"
      />
    </van-popup>
    <van-overlay :show="isProcessing"  class="overlay_loading">
      <van-loading type="spinner"/>
    </van-overlay>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";
import { Dialog } from "vant";
// 明细详情0全部1礼物收益 2礼物提成3机构礼物提成4转让5用户兑换6兑换给机构7结算佣金8提现
export default {
  data() {
    return {
      detailsColumns: [
        {id:0,text: this.$t('column.all')},
        {id:1,text: this.$t('column.gift_income')},
        {id:2,text: this.$t('column.gift_commission')},
        {id:3,text: this.$t('column.creator_commission')},
        {id:4,text: this.$t('column.Transfer')},
        {id:5,text: this.$t('column.cash_out')},
        {id:6,text: this.$t('column.exchange_to_coinseller')},
        {id:7,text: this.$t('column.official')},
        {id:8,text: this.$t('column.withdraw')}
      ],
      details_i: 0,
      detailsShow: false,
      OrderColumns: [
        {id:0,text: this.$t('column.all')},
        {id:1,text: this.$t('column.applying')},
        {id:2,text: this.$t('column.pending')},
        {id:3,text: this.$t('other.success')},
        {id:4,text: this.$t('column.failed')}
      ],
      order_i: 0,
      orderShow: false,
      navTab: 'details', // details
      details_list: [],
      list: [],
      loading: false,
      finished: false,
      page: 1,
      isProcessing: false // 切换状态
    }
  },
  created() {
   this.get_list_type()
  },
  methods: {
    tag_color(o) {
      if (o.result_status === '1') {
        return '#63dc3d';
      } else if (o.result_status === '2') {
        return '#ee5656';
      }else{
        return '#fcb923';
      }
    },
    beforeTabChange(index) {

      console.log('dddddddd')
      // 返回 false 表示阻止此次切换
      if (index === 1) {
        return false;
      }
      // 当有任务执行时禁止切换
      if (this.isProcessing) {
        this.$toast('操作进行中，请等待完成');
        return false;
      }
      return true;
    },
    ConfirmationPaymentButton(o) {
      Dialog.confirm({
        title: this.$t('column.sure_payment_has_been_made2'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=confirm_payment_success",{
          params:{
            uid: uid,
            token: token,
            order_id: o.order_id
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.page = 1
                this.finished = false
                this.get_list_type()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    OrderExceptionButton(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/help_feedback', query: { uid: uid, token: token, order_id: o.order_id } });
    },
    onConfirm(value, index) {
      this.details_i = index
      this.detailsShow = false
      this.page = 1
      this.finished = false
      this.get_list_type()
    },
    onConfirmOrder(value, index) {
      this.order_i = index
      this.orderShow = false
      this.page = 1
      this.finished = false
      this.get_list_type()
    },
    navTabBtn(){
      // 顶部切换板块
      console.log( this.navTab)
      this.page = 1
      this.finished = false
      this.details_list = []
      this.list = []
      this.isProcessing = true;
      this.get_list_type()
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.get_list_type()
      }
    },
    get_list_type(){
      if (this.navTab === 'details') {
        this.get_details_list()
      }else{
        this.get_list()
      }
    },
    get_details_list() {

      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_details_list",{
        params:{
          uid: uid,
          token: token,
          type: this.details_i,
          p: this.page
        }
      }).then(res =>{
        this.isProcessing = false
        if(res.data.status ===1){
          this.loading = false;
          if (this.page === 1) {
            this.details_list = []
          }
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.details_list.push(res.data.data.list[j])
          }
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.data.list.length < 20) {
            this.finished = true
          }
          this.page ++
        }else{
          Toast(res.data.error)
        }
      })
    },
    get_list(){

      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_withdrawal_order_list",{
        params:{
          uid: uid,
          token: token,
          status: -1,
          type: this.order_i,
          p: this.page
        }
      }).then(res =>{
        this.isProcessing = false
        if(res.data.status ===1){
          this.loading = false;
          if (this.page === 1) {
            this.list = []
          }
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.list.push(res.data.data.list[j])
          }
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.data.list.length < 20) {
            this.finished = true
          }
          this.page ++
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    copyId(creator_user_id) {
      const element = document.getElementById(creator_user_id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    cancelOrder(o) {
      Dialog.confirm({
        title: this.$t('column.is_cancel_order'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=cancel_payment",{
          params:{
            uid: uid,
            token: token,
            order_id: o.order_id
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.page = 1
                this.list = []
                this.finished = false
                this.get_list()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    approveOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/approve_order', query: { uid: uid, token: token, order_id: o.order_id } });
    },
    detailsOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/withdraw_payroll_order', query: { uid: uid, token: token, order_id: o.order_id } })
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/wallet_details.vue